import posthog from "@/lib/posthog-client";
import { installBrowserPostHogLogging } from "@/lib/posthog-logs-client";
import {
  filterAnalyticsEvent,
  REDUCED_ANALYTICS_ENABLED,
} from "@/lib/posthog-analytics-policy";

const logsConfig = {
  captureConsoleLogs: false,
  serviceName: "lore-web",
  serviceVersion: process.env.NEXT_PUBLIC_POSTHOG_RELEASE_VERSION ?? "unknown",
  environment: process.env.NODE_ENV,
};

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: "/lore-cdn",
  ui_host: "https://eu.posthog.com",
  defaults: "2026-01-30",
  capture_exceptions: true,
  before_send: (event) => filterAnalyticsEvent(event),
  ...(REDUCED_ANALYTICS_ENABLED
    ? {
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        capture_performance: false,
      }
    : {}),
  debug: process.env.NODE_ENV === "development",
  logs: logsConfig,
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: true,
    },
  },
});

installBrowserPostHogLogging();
